import useAuth from '@/auth/useAuth';
import LinkService from './LinkService';
import OverviewVisualization from './visualization';
import siteConfig from '@/config';
import Changelog from './changelog';
import { Separator } from '@/components/ui/separator';

// import { SiteConfigService } from '@/types/config';

const DashboardOverview: React.FC = () => {
  // const user = useGetUser()?.data;
  // const { workspaceId } = useParamWorkspaceId();
  const { session } = useAuth();
  const { services } = siteConfig;

  return (
    <div className="container mt-8">
      <p className="text-2xl font-medium">Welcome</p>
      <p className="text-base text-muted-foreground">{session?.user?.email}</p>

      <div className="mt-12 flex flex-col gap-12">
        <LinkService />
        {siteConfig.services.llm && <OverviewVisualization />}
      </div>
      <Separator className="mt-12" />
      <section className="py-12">
        <Changelog />
      </section>
    </div>
  );
};

export default DashboardOverview;
